<div class="content-layout right-sidebar-fullheight-basic-inner-scroll">
  <mat-drawer-container (backdropClick)="onBackdropClicked()">
    <!-- Drawer -->
    <mat-drawer [mode]="drawerMode" [opened]="false" [position]="'end'" [disableClose]="true" #matDrawer>
      <router-outlet></router-outlet>
    </mat-drawer>

    <mat-drawer-content>
      <!-- Main -->
      <div class="main">
        <div class="list-wrapper">
          <!-- Header -->
          <div class="header">
            <!-- Title -->
            <div class="title">
              <h1>PDF Reports</h1>

              <div class="contacts-count">
                <ng-container *ngIf="reportsCount > 0">
                  {{ reportsCount }}
                </ng-container>
                {{
                  reportsCount
                    | i18nPlural
                      : {
                          '=0': 'No reports',
                          '=1': 'report',
                          other: 'reports',
                        }
                }}
              </div>
            </div>

            <!-- Main actions -->
            <div class="main-actions">
              <!-- Add contact button -->
              <ts-button
                [appAuthorize]="NewPermission.PDF_REPORTS_CREATE"
                denyAction="disable"
                icon="add"
                variant="primary"
                (click)="createReportLayout()"
              >
                New PDF Report
              </ts-button>
            </div>
          </div>

          <!-- Contacts list -->
          <div class="contacts-list">
            <div class="table-wrapper">
              <div class="inline-table-wrapper">
                <ng-container *ngIf="reportsCount > 0; else noContacts">
                  <!-- Table -->
                  <table
                    mat-table
                    matSort
                    [matSortActive]="'name'"
                    [matSortDisableClear]="true"
                    [matSortDirection]="'asc'"
                    (matSortChange)="sortChanged($event)"
                    [dataSource]="reportLayouts"
                    [trackBy]="trackByFn"
                  >
                    <!-- Name -->
                    <ng-container matColumnDef="name">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
                      <td [routerLink]="['./' + reportLayout.id]" mat-cell *matCellDef="let reportLayout">
                        <div class="name-content">
                          <span class="name"
                            ><a>{{ reportLayout.name }}</a></span
                          >
                        </div>
                      </td>
                    </ng-container>

                    <!-- Email -->
                    <ng-container matColumnDef="created_at">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Created</th>
                      <td [routerLink]="['./' + reportLayout.id]" mat-cell *matCellDef="let reportLayout">
                        {{ reportLayout.created_at | date: 'MMM dd, y' }}
                      </td>
                    </ng-container>
                    <!-- Email -->
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef>Actions</th>
                      <td [routerLink]="['./' + reportLayout.id]" mat-cell *matCellDef="let reportLayout">
                        <a>
                          <mat-icon [svgIcon]="'visibility'" *ngIf="!reportLayout.running"></mat-icon>
                        </a>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="reportsTableColumns; sticky: true"></tr>
                    <tr class="contact-row" mat-row *matRowDef="let reportLayout; columns: reportsTableColumns"></tr>
                  </table>
                </ng-container>
              </div>

              <ng-template #noContacts>
                <div class="no-contacts">There are no reports!</div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
